<div class="no-data">
    <i class="{{icon}} icon"> </i>
    <h4 class="title"> {{title}} </h4>
    <p class="description"> {{description}} </p>
</div>
